import { cn } from '~/utils/cn';

import type { StatusTone } from '../../../types/chatbot-message.types';

/** Tone → token-class mapping. Centralized so every status / recommendation / trend uses identical theming. */
const TONE_CLASSES: Record<StatusTone, string> = {
  success: 'bg-success-50 text-success',
  warning: 'bg-warning-50 text-warning',
  info: 'bg-info-50 text-info',
  error: 'bg-error-50 text-error',
};

/** Small inline pill conveying status — used inside StatusCard / RecommendationCard. */
export function StatusBadge({
  tone,
  children,
  className,
}: {
  tone: StatusTone;
  children: React.ReactNode;
  className?: string | undefined;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold',
        TONE_CLASSES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
